/* Robomate Domestic header: mega menus, dropdowns, search row, mobile drawer. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.rmdhReady) return;
    root.dataset.rmdhReady = '1';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-rmdh-item]'));
    var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');
    var closeTimer;

    function panelOf(item) { return item.querySelector('[data-rmdh-panel]'); }
    function triggerOf(item) { return item.querySelector('[data-rmdh-trigger]'); }

    function closeAll(except) {
      items.forEach(function (it) {
        if (it === except) return;
        var p = panelOf(it), t = triggerOf(it);
        if (p) p.hidden = true;
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
    function open(item) {
      closeAll(item);
      var p = panelOf(item), t = triggerOf(item);
      if (!p) return;
      p.hidden = false;
      t.setAttribute('aria-expanded', 'true');
      // Simple dropdowns line up under their menu item
      if (p.classList.contains('rmdh-drop')) {
        var bar = root.querySelector('.rmdh-bar');
        var left = t.getBoundingClientRect().left - bar.getBoundingClientRect().left;
        var maxLeft = bar.clientWidth - 248;
        p.style.left = Math.max(8, Math.min(left, maxLeft)) + 'px';
      }
    }
    function toggle(item) {
      var t = triggerOf(item);
      if (t.getAttribute('aria-expanded') === 'true') closeAll(); else open(item);
    }

    items.forEach(function (item) {
      var t = triggerOf(item);
      t.addEventListener('click', function (e) { e.preventDefault(); toggle(item); });
      item.addEventListener('mouseenter', function () {
        if (!hoverable.matches) return;
        clearTimeout(closeTimer);
        open(item);
      });
      item.addEventListener('mouseleave', function () {
        if (!hoverable.matches) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () { closeAll(); }, 180);
      });
    });

    document.addEventListener('click', function (e) { if (!root.contains(e.target)) closeAll(); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openItem = items.filter(function (it) { return triggerOf(it).getAttribute('aria-expanded') === 'true'; })[0];
      closeAll();
      if (openItem) triggerOf(openItem).focus();
      if (drawer && !drawer.hidden) setDrawer(false);
    });

    // Sticky: let the trust bar scroll away, keep the main bar at the top
    var section = root.closest('.shopify-section') || root.parentElement;
    var topbar = root.querySelector('.rmdh-top');
    function measure() {
      var h = topbar ? topbar.offsetHeight : 0;
      if (section) section.style.setProperty('--rmdh-topbar', h + 'px');
      return h;
    }
    var topH = measure();
    window.addEventListener('resize', function () { topH = measure(); });
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        root.classList.toggle('is-stuck', window.scrollY > topH + 2);
        ticking = false;
      });
    }, { passive: true });

    // Search row
    var searchBtn = root.querySelector('[data-rmdh-search-toggle]');
    var searchRow = root.querySelector('[data-rmdh-search]');
    if (searchBtn && searchRow) {
      searchBtn.addEventListener('click', function () {
        var show = searchRow.hidden;
        searchRow.hidden = !show;
        searchBtn.setAttribute('aria-expanded', show ? 'true' : 'false');
        if (show) { closeAll(); var input = searchRow.querySelector('input[type="search"]'); if (input) input.focus(); }
      });
    }

    // Mobile drawer
    var burger = root.querySelector('[data-rmdh-burger]');
    var drawer = root.querySelector('[data-rmdh-drawer]');
    function setDrawer(show) {
      if (!drawer) return;
      if (show) {
        var bar = root.querySelector('.rmdh-bar');
        root.style.setProperty('--rmdh-top', Math.max(0, bar.getBoundingClientRect().bottom) + 'px');
      }
      drawer.hidden = !show;
      burger.setAttribute('aria-expanded', show ? 'true' : 'false');
      burger.setAttribute('aria-label', show ? 'Close menu' : 'Open menu');
      document.documentElement.classList.toggle('rmdh-lock', show);
    }
    if (burger && drawer) {
      burger.addEventListener('click', function () { setDrawer(drawer.hidden); });
      window.addEventListener('resize', function () { if (window.innerWidth >= 1100 && !drawer.hidden) setDrawer(false); });
    }
  }

  function boot() { document.querySelectorAll('[data-rmdh]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();